
import { defineComponent , computed} from 'vue';
import { useTenantStore } from '@/stores/tenant';

export default defineComponent({
    props: {
        me: Object,
        value: Object,
        loading: Boolean,
    },
    setup() {
        const tab: string = null;
        const tenantStore = useTenantStore();
        const tabs = computed(() =>
            [
                { key: 'usage', icon: 'insights', text: 'views.dialogGeography.tabs.usage' },
                tenantStore.hasTenantFeature('EmissionsAndEnergy')
                    ? { key: 'carbon', icon: 'co2', text: 'views.dialogGeography.tabs.carbon' }
                    : null,
            ].filter((t) => t)
        );
        return { tab, tabs };
    },
});
